var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C31.6304 50 37.9893 47.3661 42.6777 42.6777C47.3661 37.9893 50 31.6304 50 25C50 18.3696 47.3661 12.0107 42.6777 7.32233C37.9893 2.63392 31.6304 0 25 0C18.3696 0 12.0107 2.63392 7.32233 7.32233C2.63392 12.0107 0 18.3696 0 25C0 31.6304 2.63392 37.9893 7.32233 42.6777C12.0107 47.3661 18.3696 50 25 50ZM17.0898 17.0898C18.0078 16.1719 19.4922 16.1719 20.4004 17.0898L24.9902 21.6797L29.5801 17.0898C30.498 16.1719 31.9824 16.1719 32.8906 17.0898C33.7988 18.0078 33.8086 19.4922 32.8906 20.4004L28.3008 24.9902L32.8906 29.5801C33.8086 30.498 33.8086 31.9824 32.8906 32.8906C31.9727 33.7988 30.4883 33.8086 29.5801 32.8906L24.9902 28.3008L20.4004 32.8906C19.4824 33.8086 17.998 33.8086 17.0898 32.8906C16.1816 31.9727 16.1719 30.4883 17.0898 29.5801L21.6797 24.9902L17.0898 20.4004C16.1719 19.4824 16.1719 17.998 17.0898 17.0898Z",
    fill: "#303A46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.161476209157ac1b88c73cdc8e568712.svg";
export { ForwardRef as ReactComponent };